module.exports = __webpack_public_path__ + "img/企业信用评分证书.6e40f443.svg";